import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        selectionList({commit, dispatch, rootState}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/spa-manager/services/selection-list',
                    { params: filter }
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        fetch({commit, dispatch}, filter) {
            return new Promise((resolve) => {
                commit('TOGGLE_PRELOADER', true, {root: true})
                axios.get(
                    '/api/spa-manager/services/list',
                    { params: filter }
                ).then(({data}) => {
                    resolve({data})
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                })
            })
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/spa-manager/services/add',
                    prepareData(data)
                ).then(({data}) => {
                    resolve(data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/spa-manager/services/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/spa-manager/services/dell/' + itemId
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('intro', data.intro)
    fd.append('prices', JSON.stringify(data.prices))
    if (data.description) {
        fd.append('description', data.description)
    }

    if (data.price_value) {
        fd.append('price_value', data.price_value)
    }
    fd.append('published', Number(data.published))
    fd.append('spa_salon_id', Number(data.spa_salon_id))

    return fd
}
